import { render } from "./VehicleCardDesktop.vue?vue&type=template&id=47499b5b&scoped=true"
import script from "./VehicleCardDesktop.vue?vue&type=script&lang=js"
export * from "./VehicleCardDesktop.vue?vue&type=script&lang=js"

import "./VehicleCardDesktop.vue?vue&type=style&index=0&id=47499b5b&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47499b5b"]])

export default __exports__